var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9303 10.6625V37.3375H8V10.6625H12.9303ZM28.8215 10C28.778 10 28.7356 10.0006 28.692 10.0006C25.2625 10.0325 21.9989 11.4358 19.5027 13.953C17.0063 16.4702 15.5517 19.8246 15.4078 23.398C15.2521 27.248 16.5751 30.9003 19.1322 33.6824C21.6918 36.4667 25.132 38 28.8194 38C32.6027 38 36.4972 36.3973 39 33.8135V21.9633H28.3388V26.9002H34.2018V31.2436L34.1384 31.2873C32.6628 32.302 30.74 32.9577 28.8188 32.9577C26.4428 32.9577 24.2305 31.9649 22.5901 30.1617C20.9513 28.3607 20.118 26.0026 20.2426 23.5212C20.468 19.0283 24.0238 15.3105 28.3377 15.0574C30.7352 14.9129 33.021 15.9382 34.8429 17.761C34.9073 17.826 34.9809 17.9067 35.0652 18.0069L38.484 14.4414C38.4078 14.3557 38.3331 14.2728 38.2622 14.1955C35.8309 11.5484 32.512 10 28.8215 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgWhite);
export default __webpack_public_path__ + "static/media/ig_white.97d756a58c64753730c74fdb080a04e1.svg";
export { ForwardRef as ReactComponent };